var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13208_11716)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.8095,
    height: 22,
    transform: "translate(0.177734)",
    fill: "#ADADAD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13208_11716",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.177734 1.90735e-06H21.9873V22H0.177734V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13208_11716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5763 15.1169V20.3906C20.5763 21.1025 20.0041 21.6797 19.2984 21.6797H2.86677C2.16103 21.6797 1.58887 21.1025 1.58887 20.3906V18.5974",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8219 20.3906H2.8689C2.16196 20.3906 1.58887 19.8125 1.58887 19.0994V3.08814C1.58887 2.37503 2.16196 1.79693 2.8689 1.79693H19.2962C20.0032 1.79693 20.5763 2.37503 20.5763 3.08814V15.5947C20.5763 15.9372 20.4414 16.2656 20.2013 16.5078L16.727 20.0124C16.4869 20.2546 16.1614 20.3906 15.8219 20.3906Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2969 20.3906C15.8761 20.3906 16.3457 19.917 16.3457 19.3326V17.1815C16.3457 16.5972 16.8152 16.1235 17.3945 16.1235H19.527C20.1063 16.1235 20.5758 15.6499 20.5758 15.0656",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36609 6.40234H1.58887",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5768 6.40234H6.64453",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20574 3.72266C4.84563 3.72266 4.55371 3.42819 4.55371 3.06493V0.980133C4.55371 0.616875 4.84563 0.32241 5.20574 0.32241H5.3524C5.71251 0.32241 6.00443 0.616875 6.00443 0.980133V1.79512",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8132 3.72266C16.453 3.72266 16.1611 3.42819 16.1611 3.06493V0.980133C16.1611 0.616875 16.453 0.32241 16.8132 0.32241H16.9598C17.3199 0.32241 17.6118 0.616875 17.6118 0.980133V1.79512",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33143 10.4844H3.81013C3.64208 10.4844 3.50586 10.347 3.50586 10.1774V8.64286C3.50586 8.47335 3.64208 8.33594 3.81013 8.33594H5.33143C5.49947 8.33594 5.6357 8.47335 5.6357 8.64286V10.1774C5.6357 10.347 5.49947 10.4844 5.33143 10.4844Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67225 10.4844H8.15095C7.9829 10.4844 7.84668 10.347 7.84668 10.1774V8.64286C7.84668 8.47335 7.9829 8.33594 8.15095 8.33594H9.67225C9.84029 8.33594 9.97652 8.47335 9.97652 8.64286V10.1774C9.97652 10.347 9.84029 10.4844 9.67225 10.4844Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.014 10.4844H12.4927C12.3247 10.4844 12.1885 10.347 12.1885 10.1774V8.64286C12.1885 8.47335 12.3247 8.33594 12.4927 8.33594H14.014C14.1821 8.33594 14.3183 8.47335 14.3183 8.64286V10.1774C14.3183 10.347 14.1821 10.4844 14.014 10.4844Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3549 10.4844H16.8336C16.6655 10.4844 16.5293 10.347 16.5293 10.1774V8.64286C16.5293 8.47335 16.6655 8.33594 16.8336 8.33594H18.3549C18.5229 8.33594 18.6591 8.47335 18.6591 8.64286V10.1774C18.6591 10.347 18.5229 10.4844 18.3549 10.4844Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33143 14.4688H3.81013C3.64208 14.4688 3.50586 14.3313 3.50586 14.1618V12.6272C3.50586 12.4577 3.64208 12.3203 3.81013 12.3203H5.33143C5.49947 12.3203 5.6357 12.4577 5.6357 12.6272V14.1618C5.6357 14.3313 5.49947 14.4688 5.33143 14.4688Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67225 14.4688H8.15095C7.9829 14.4688 7.84668 14.3313 7.84668 14.1618V12.6272C7.84668 12.4577 7.9829 12.3203 8.15095 12.3203H9.67225C9.84029 12.3203 9.97652 12.4577 9.97652 12.6272V14.1618C9.97652 14.3313 9.84029 14.4688 9.67225 14.4688Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0131 14.4688H12.4918C12.3237 14.4688 12.1875 14.3313 12.1875 14.1618V12.6272C12.1875 12.4577 12.3237 12.3203 12.4918 12.3203H14.0131C14.1811 12.3203 14.3173 12.4577 14.3173 12.6272V14.1618C14.3173 14.3313 14.1811 14.4688 14.0131 14.4688Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3549 14.5664H16.8336C16.6655 14.5664 16.5293 14.429 16.5293 14.2595V12.7249C16.5293 12.5554 16.6655 12.418 16.8336 12.418H18.3549C18.5229 12.418 18.6591 12.5554 18.6591 12.7249V14.2595C18.6591 14.429 18.5229 14.5664 18.3549 14.5664Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33143 18.457H3.81013C3.64208 18.457 3.50586 18.3196 3.50586 18.1501V16.6155C3.50586 16.446 3.64208 16.3086 3.81013 16.3086H5.33143C5.49947 16.3086 5.6357 16.446 5.6357 16.6155V18.1501C5.6357 18.3196 5.49947 18.457 5.33143 18.457Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67225 18.457H8.15095C7.9829 18.457 7.84668 18.3196 7.84668 18.1501V16.6155C7.84668 16.446 7.9829 16.3086 8.15095 16.3086H9.67225C9.84029 16.3086 9.97652 16.446 9.97652 16.6155V18.1501C9.97652 18.3196 9.84029 18.457 9.67225 18.457Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1885 17.0581V16.6155C12.1885 16.446 12.3247 16.3086 12.4927 16.3086H14.014C14.1821 16.3086 14.3183 16.446 14.3183 16.6155V18.1501C14.3183 18.3196 14.1821 18.457 14.014 18.457H12.4927C12.3247 18.457 12.1885 18.3196 12.1885 18.1501",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13208_11716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8095,
    height: 22,
    fill: "white",
    transform: "translate(0.177734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7be58537e458c96906c876e2c62d7a3a.svg";
export { ForwardRef as ReactComponent };